import { jsxs as m, jsx as n } from "react/jsx-runtime";
import { useFloating as b } from "../../node_modules/.pnpm/@floating-ui_react@0.27.16_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react/dist/floating-ui.react.js";
import { useId as v, useState as h } from "react";
import { useEscapeKey as E } from "../../utils/use-escape-key.js";
import { useFocusOutside as N } from "../../utils/use-focus-outside.js";
import s from "./roche-popover.module.scss.js";
import { autoUpdate as F } from "../../node_modules/.pnpm/@floating-ui_dom@1.7.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset as w, shift as R, size as S, limitShift as j } from "../../node_modules/.pnpm/@floating-ui_react-dom@2.1.6_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
const u = 8, y = 8, B = ({ trigger: _, footer: l, children: g, onOpenChange: r, panelWidth: p }) => {
  const i = v(), d = v(), [e, I] = h(!1), { refs: o, floatingStyles: P } = b({
    strategy: "fixed",
    placement: "bottom-start",
    middleware: [
      w(u),
      R({ padding: y, limiter: j({ offset: u }) }),
      S({
        padding: y,
        apply: ({ availableWidth: t, availableHeight: x, elements: f }) => {
          f.floating.style.setProperty("--popover-available-width", `${t}px`), f.floating.style.setProperty("--popover-available-height", `${x}px`);
        }
      })
    ],
    whileElementsMounted: F
  }), c = (t) => {
    I(t), r == null || r(t);
  }, a = () => {
    e && c(!1);
  };
  return E(() => {
    var t;
    a(), (t = document.getElementById(i)) == null || t.focus();
  }, e), N(o.floating, e, a, o.domReference), /* @__PURE__ */ m("div", { ref: o.setReference, className: s.popover, children: [
    _(
      { id: i, "aria-expanded": e, "aria-controls": d, onClick: () => c(!e) },
      e
    ),
    e && /* @__PURE__ */ m(
      "section",
      {
        id: d,
        ref: o.setFloating,
        style: {
          ...P,
          ...p !== void 0 && { "--popover-panel-width": p }
        },
        "aria-labelledby": i,
        tabIndex: -1,
        className: s.popover__panel,
        children: [
          /* @__PURE__ */ n("div", { className: s.popover__content, children: g }),
          l && /* @__PURE__ */ n("div", { className: s.popover__footer, children: l(a) })
        ]
      }
    )
  ] });
};
export {
  B as RocheUIPopover
};
